import {
  AirportDropDownList,
  CityData
} from '@com-delta-idp/mnx-sitewide-shared-core-ui';
import { FlightStatusContainerSuperBaseComponent } from './flight-status-container-super-base.component';

export class FlightStatusContainerBaseComponent extends FlightStatusContainerSuperBaseComponent {
  protected initializeAirportModalContent(): void {
    this.airportModalContent = this.helper.initializeAirportModalContent();
  }

  searchForAirport(searchTerm: string): void {
    this.flightStatusFacade.airportSearchErrorService.clearError();

    if (this.isPrefilledValue) {
      this.isPrefilledValue = false;
      return;
    }

    if (this.checkInvalidInput(searchTerm)) {
      this.handleInvalidInput(searchTerm);
      return;
    }
    if (searchTerm.length !== 3) return;
    this.performAirportSearch(searchTerm);
  }

  private performAirportSearch(searchTerm: string): void {
    const searchQuery = searchTerm.substring(0, 3);
    if (this.lastApiCall === searchQuery) {
      this.handleErrorForDuplicateSearch(searchQuery);
      return;
    }

    this.lastApiCall = searchQuery;
    this.flightStatusFacade.predictiveCities = [];
    this.flightStatusFacade.searchForAirport(searchQuery);
  }

  handleInvalidInput(searchTerm: string): void {
    this.lastApiCall = '';
    this.flightStatusFacade.predictiveCities = [];
    this.openModalEvent = false;
    setTimeout(() => {
      this.airportModalContent = this.helper.initializeAirportModalContent();
      this.flightStatusFacade.airportSearchErrorService.handleEmptyResults(
        0,
        searchTerm
      );
      this.openModalEvent = true;
    }, 100);
  }

  private handleErrorForDuplicateSearch(searchQuery: string): void {
    if (this.flightStatusFacade.airportSearchErrorService._errorFlag) {
      this.flightStatusFacade.airportSearchErrorService.handleEmptyResults(
        0,
        searchQuery
      );
    }
  }

  protected updateSearchResults(cities: CityData[]): void {
    // Update airportModalContent completely like check-in does
    this.airportModalContent = this.helper.initializeAirportModalContent();
    const searchResults = this.helper.updateSearchResults(cities);
    this.airportModalContent.airportList.items = searchResults;

    if (this.destinationType === 'From') {
      this.originAirportSearchResults = searchResults;
    } else {
      this.destinationAirportSearchResults = searchResults;
    }

    if (cities.length > 0) {
      this.rebuildSearchComponent();
    }
  }

  private rebuildSearchComponent(): void {
    const newInstance = this.helper.rebuildSearchComponent(
      this.airportModalContent,
      (searchTerm: string) => this.searchForAirport(searchTerm),
      (selectedItem: CityData) => this.onAirportSelected(selectedItem)
    );
    if (newInstance) this.searchInstance = newInstance;
  }

  protected initializeSearchComponent(): void {
    if (this.searchInstance) return;
    const newInstance = this.helper.initializeSearchComponent(
      this.airportModalContent,
      (searchTerm: string) => this.searchForAirport(searchTerm),
      (selectedItem: CityData) => this.onAirportSelected(selectedItem)
    );
    if (newInstance) this.searchInstance = newInstance;
  }

  onAirportSelected(airport: CityData | AirportDropDownList): void {
    const selectedAirport = this.isCityData(airport)
      ? this.convertCityDataToAirportDropDown(airport)
      : airport;

    if (this.destinationType === 'From') {
      this.originAirport = { ...selectedAirport };
    } else {
      this.destinationAirport = { ...selectedAirport };
    }

    this.closeModal();
    this.focusAirportButton();
  }

  private focusAirportButton(): void {
    setTimeout(() => {
      document
        .getElementById(
          `flight-status-airport-code-${
            this.destinationType === 'From' ? 'origin' : 'destination'
          }-trigger`
        )
        ?.focus();
    }, 100);
  }

  private isCityData(
    airport: CityData | AirportDropDownList
  ): airport is CityData {
    return 'id' in airport && 'label' in airport;
  }

  private convertCityDataToAirportDropDown(
    city: CityData
  ): AirportDropDownList {
    return this.helper.convertCityDataToAirportDropDown(city);
  }

  private closeModal(): void {
    this.helper.closeModal();
  }

  protected handleDataReady(): void {
    const cities = this.flightStatusFacade.predictiveCities || [];
    if (cities.length > 0) {
      this.updateSearchResults(cities);
    }
  }
}
